module.exports = __webpack_public_path__ + "static/media/eval-general.5ee515f2.png";